/**
 * Services landing.
 */
class Services extends DrupalBehavior {
    onReady(document) {
      $('.pager').each((index, pager) => {
        if (index > 0) {
          const label = $(pager).attr('aria-labelledby');
          $(pager).attr('aria-labelledby', `${label}-${index}`)
          $(pager).find(`#${label}`).attr('id', `${label}-${index}`)
        }
      });
    }
  }

  DrupalBehavior.register('camc.pages', 'doctor full', Services);
